import axios from "../../config/axiosConfig";
import {
  GST_REFUND_REPORT_REQUEST,
  GST_REFUND_REPORT_SUCCESS,
  GST_REFUND_REPORT_FAILURE,
} from "../types/gst-refund-report-types";

export const getGSTRefundReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GST_REFUND_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
    
      const requestParams = { ...defaultParams, ...params };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/gst-refund-report/getReport?${queryString}`;
      console.log('Complete GSTR9 API Request URL: ', fullUrl);
      return axios.get('/gst-refund-report/getReport', { params: requestParams }).then((response) => {
        if (response) {
          dispatch({ 
            type: GST_REFUND_REPORT_SUCCESS, 
            payload: response 
          });
          console.log("Actions Api Call" , response);
          
          return response;
        } else {
          throw new Error(response.data?.message || 'Failed to fetch GSTR2 report');
        }
      }).catch((error) => {
        console.error("Error fetching GSTR9 Report:", error);
        dispatch({ 
          type: GST_REFUND_REPORT_FAILURE, 
          error: error.response?.data?.message || error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GSTR9 Report:", error);
      dispatch({ 
        type: GST_REFUND_REPORT_FAILURE, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  };
};
